import { getFeatureData } from 'config-request';
import { CategoryCode, FeatureType, SubCategoryCode, } from 'config-request/src/interfaces/feature-list';
import { defineStore } from 'pinia';
import { useFeatureListStore } from './feature-list';
import { useOptionImageStore } from './option-image';
import { usePriceListStore } from './price-list';
export const useInteriorCustomStore = defineStore('interior-custom', {
    state() {
        return {
            optionImgMap: {},
        };
    },
    getters: {
        /**
         * 座舱定制配置项列表
         */
        interiorList() {
            const featureListStore = useFeatureListStore();
            const optionImageStore = useOptionImageStore();
            const priceList = usePriceListStore();
            if (!featureListStore.data)
                return [];
            const interiorCustomCodes = [
                CategoryCode.Cockpit,
                SubCategoryCode.CockpitCustom,
                FeatureType.CockpitCustom,
            ];
            const interiorCustomItem = getFeatureData(interiorCustomCodes, featureListStore.data);
            return interiorCustomItem?.option_list?.map((option) => {
                const item = featureListStore.data?.option_map[option];
                // const priceDiscountTip =
                //   priceList.data?.configurator_select_discount_tip_map?.[option] || ''
                const priceDiscountTipIcon = priceList.data?.configurator_select_discount_tip_icon_map?.[option] || {
                    icon: '',
                    icon_ratio: 0,
                };
                if (!item?.code)
                    return {
                        ...item,
                        overViewImg: null,
                        discount_selected: false,
                        discount_tip: '',
                    };
                const discountData = {
                    // discount_selected: !!priceDiscountTip,
                    // discount_tip: priceDiscountTip || item?.discount_tip || '',
                    discount_tip_icon: priceDiscountTipIcon?.icon || item?.discount_tip_icon || '',
                    discount_tip_icon_ratio: priceDiscountTipIcon?.icon_ratio || item?.discount_tip_icon_ratio || 0,
                };
                const img = optionImageStore.interiorCustomImgs?.[item.code]?.img_url_list?.[0] ??
                    this.optionImgMap[item?.code];
                this.optionImgMap[item?.code] = img;
                return {
                    ...item,
                    overViewImg: img,
                    ...discountData,
                };
            });
        },
    },
});
